import { z } from "zod";

export const MAX_AGENT_CONTEXT_BYTES = 1_024;

export const agentContextSchema = z
    .record(z.string(), z.json())
    .refine(
        (value) =>
            new TextEncoder().encode(JSON.stringify(value)).byteLength <=
            MAX_AGENT_CONTEXT_BYTES,
        { message: "Agent context exceeds the byte limit" },
    );

export type AgentContextValue = z.infer<typeof agentContextSchema>;
